export default
{
    methods:
    {
        emitValue()
        {
            let $_files = this.uploadedFiles.filter( file => file.status === 'success' ).map( file => { return { id: file?.finalId || file.id, name: file.name, type: file.type, size: file.size } } );

            if( !this.multiple ) { $_files = $_files[0]; }

            this.$emit( 'update:modelValue', $_files );
        },

        setInternalValueFromModelValue( value )
        {
            this.uploadedFiles.push( this.getItemObject( undefined, { id: value?.id || Date.now(), url: this.url }, { name: value.name || '', type: value.type, status: 'success', progress: 100, size: value.size } ) );
        },

        getItemObject( xhr, url, file )
        {
            return (
            {
                id             : url?.id || file?.lastModified || Date.now(),
                url            : url.url,
                name           : file.name,
                type           : file.type,
                size           : file.size,
                status         : file.status || 'ready',
                progress       : file.progress || 0,
                removeCallback : this.getRemoveItemCallbackFunction( xhr, { ...url, id: url?.id || file?.lastModified || Date.now() } )
            });
        },

        getRemoveItemCallbackFunction( xhr, url )
        {
            return () =>
            {
                if( xhr ) { xhr.abort(); }

                const index = this.uploadedFiles.findIndex( item => url.id === item.id );

                ( index > -1 ) && this.uploadedFiles.splice( index, 1 );

                this.emitValue();
            }
        },

        onDragEnter( event )
        {
            this.$emit( 'drag:enter', event );

            this.dragEnter = true;
        },

        onDragLeave( event )
        {
            this.$emit( 'drag:leave', event );

            this.dragEnter = false;
        },

        onDrop( event )
        {
            this.$emit( 'on:drop', event );

            this.dragEnter = false;

            this.upload( event.dataTransfer );
        },

        async upload( event )
        {
            if( !event || !event.files || !event.files.length )
            {
                console.warn('No files to upload', event );

                return;
            }

            this.isUploading = true;

            this.$emit( 'upload:start', event );

            try
            {
                ( !this.multiple ) && ( this.uploadedFiles.map( file => file?.removeCallback() ) );

                let files = ( !this.multiple && event.files.length > 1 ) ? [ event.files[0] ] : event.files;

                const validExtensions = this.accept.split(',').map( ext => ext.trim() );

                for( let file of files )
                {
                    const fileName      = file.name.toLowerCase();
                    const fileExtension = fileName.substring( fileName.lastIndexOf('.') ).substring(1);

                    if( this.accept && this.accept !== '*' && !validExtensions.find( ext => ext.includes( fileExtension ) || ext.includes( file.type ) ) )
                    {
                        console.warn('Invalid file type', { file, validExtensions });

                        continue;
                    }

                    if( this.uploadedFiles.find( f => ( f.name === file.name ) && ( f.size === file.size ) && ( f.type === file.type ) ) )
                    {
                        console.warn('File already uploaded', { file });

                        continue;
                    }

                    let $_URL;

                    if( !this.url )
                    {
                        throw { statusCode: 500, status: 'error', message: 'No URL provided for file upload' };
                    }

                    if( typeof this.url === 'function' )
                    {
                        $_URL = await this.url({ name: file.name, type: file.type });

                        if( $_URL?.status && ( $_URL?.status !== 200 ) )
                        {
                            throw { statusCode: $_URL.status, status: 'error', message: $_URL.statusText || 'Error getting URL for file upload' };
                        }
                    }
                    else if( typeof this.url === "object" )
                    {
                        $_URL = this.url;
                    }
                    else
                    {
                        $_URL = { id: Date.now(), url: this.url }
                    }

                    const xhr = new XMLHttpRequest();

                    const fileItem = this.getItemObject( xhr, $_URL, file );

                    this.uploadedFiles.push( fileItem );

                    const fileIndex = this.uploadedFiles.findIndex( ( f ) => f.id === fileItem.id );

                    xhr.upload.onprogress = ( e ) =>
                    {
                        this.uploadedFiles[fileIndex].progress = Math.round( ( e.loaded / e.total ) * 100 );
                    };

                    xhr.onload = () =>
                    {
                        if( xhr.status >= 200 && xhr.status < 300 )
                        {
                            let response = JSON.parse( xhr.responseText );

                            this.uploadedFiles[fileIndex].finalId = response.id;
                            this.uploadedFiles[fileIndex].status  = 'success';
                        }
                        else
                        {
                            console.warn('Error uploading file:', { xhr, file });

                            this.uploadedFiles[fileIndex].status = 'error';

                            //this.uploadedFiles.splice( fileIndex, 1 );

                            this.statusCode = xhr.status;

                            //throw { statusCode: xhr.status, status: 'error', message: xhr.statusText || 'Error uploading file' };
                        }

                        this.emitValue();
                    };

                    xhr.onerror = () =>
                    {
                        console.warn('Error uploading file:', { xhr, file });

                        this.uploadedFiles[fileIndex].status = 'error';

                        //this.uploadedFiles.splice( fileIndex, 1 );

                        this.statusCode = xhr.status;

                        this.emitValue();

                        //throw { statusCode: xhr.status, status: 'error', message: xhr.statusText || 'Error uploading file' };
                    };

                    xhr.open('PUT', $_URL.url, true );

                    if( Object?.keys( this?.headers || {} )?.length )
                    {
                        Object.keys( this.headers ).forEach( key =>
                        {
                            xhr.setRequestHeader( key, this.headers[key] );
                        });
                    }

                    xhr.withCredentials = true;

                    //xhr.overrideMimeType( file.type );

                    const formData = new FormData();
                          formData.append( 'file', file );

                    xhr.send( formData );
                }
            }
            catch( error )
            {
                console.warn('Error uploading file:', error );

                this.statusCode = error?.statusCode || error?.status || 500;
            }

            this.isUploading = false;

            this.$emit( 'upload:end', event );
        }
    }
}